/** @module resources */
import { fetchPost } from 'app/utils/request';

function SmartListFactory ($resource, $http) {
  var SmartList = $resource({
    url: 'api/v2/smart_lists',
    name: 'smartList'
  });

  SmartList.prototype.addMember = function(member) {
    return fetchPost(URL.addMember({ id: this.id }), member);
  };

  SmartList.prototype.spaces = function() {
    return $http.get(this.$url('spaces'));
  };

  SmartList.prototype.spacesCount = function() {
    return this.spaceIds.length;
  };

  SmartList.prototype.spacesCountWithTitle = function() {
    return this.spaceIds.length + " Spaces";
  };

  SmartList.prototype.hasSpaces = function() {
    return this.spacesCount() > 0;
  };

  // Plan Permissions

  SmartList.prototype.planCanPost = function () {
    return (this.planPermissions.indexOf('post') !== -1);
  };

  SmartList.prototype.planCanInvite = function () {
    return (this.planPermissions.indexOf('invite') !== -1);
  };

  SmartList.prototype.planCanManageSpaces = function () {
    return (this.planPermissions.indexOf('manage_spaces') !== -1);
  };

  SmartList.prototype.planCanEdit = function () {
    return (this.planPermissions.indexOf('edit') !== -1);
  };

  SmartList.prototype.planCanDelete = function () {
    return (this.planPermissions.indexOf('delete') !== -1);
  };

  return SmartList;
}

SmartListFactory.$inject = ['core.services.$resource', '$http'];

export default SmartListFactory;
